import { motion } from "framer-motion";

const ARTIST_IMG = "https://images.unsplash.com/photo-1633887091219-265c29eac4cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";
const STUDIO_IMG = "https://images.pexels.com/photos/8968525/pexels-photo-8968525.jpeg?auto=compress&cs=tinysrgb&w=1000";

const artists = [
  {
    name: "Camille Rousseau",
    img: "https://images.unsplash.com/photo-1520207588543-1e545b20c19e?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    text: "Atteinte de paralysie cérébrale, Camille a fait de la peinture un langage à part entière, libre et fulgurant.",
  },
  {
    name: "Julien Mercier",
    img: "https://images.unsplash.com/photo-1626555019243-638888e7dc3a?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    text: "Malvoyant depuis l'enfance, Julien perçoit le monde par contrastes et le restitue avec une intensité rare.",
  },
  {
    name: "Sofia Lambert",
    img: "https://images.unsplash.com/photo-1633887091219-265c29eac4cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    text: "En fauteuil roulant suite à un accident, Sofia transforme son atelier en refuge chromatique éclatant.",
  },
];

export default function About() {
  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid="about-page">
      {/* Intro */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#60a5fa] mb-5">Notre mission</p>
          <h1 className="font-display text-5xl md:text-6xl text-white tracking-tight leading-[1.05] mb-8">
            L'art comme acte de <span className="italic text-[#60a5fa]">résistance</span>.
          </h1>
          <p className="text-zinc-300 leading-relaxed mb-5">
            La Fondation des Artistes Handicapées de France soutient et met en lumière des créateurs
            en situation de handicap. Loin des regards, ils transforment leurs contraintes en une
            puissance créative bouleversante.
          </p>
          <p className="text-zinc-400 leading-relaxed">
            Chaque tableau vendu sur cette plateforme reverse une part majeure directement à son artiste,
            lui offrant reconnaissance et autonomie. Acheter une œuvre, c'est offrir une voix.
          </p>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="aspect-[4/5] overflow-hidden bg-[#0d0d0d]"
        >
          <img src={ARTIST_IMG} alt="Artiste en atelier" className="h-full w-full object-cover" />
        </motion.div>
      </section>

      {/* Quote */}
      <section className="max-w-4xl mx-auto px-6 lg:px-10 py-28 text-center">
        <p className="font-display text-3xl md:text-5xl text-white italic leading-tight">
          « Je ne peins pas avec mes mains, je peins avec tout ce qui m'a été refusé. »
        </p>
        <p className="text-zinc-500 mt-6 uppercase tracking-widest text-sm">— Un artiste de la Fondation</p>
      </section>

      {/* Artists */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10">
        <h2 className="font-display text-4xl md:text-5xl text-white tracking-tight mb-14">Les artistes</h2>
        <div className="grid md:grid-cols-3 gap-10">
          {artists.map((a, i) => (
            <motion.div
              key={a.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              data-testid={`artist-${i}`}
            >
              <div className="aspect-[3/4] overflow-hidden bg-[#0d0d0d] mb-5">
                <img src={a.img} alt={a.name} className="h-full w-full object-cover" />
              </div>
              <h3 className="font-display text-2xl text-white mb-2">{a.name}</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">{a.text}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Studio banner */}
      <section className="max-w-7xl mx-auto px-6 lg:px-10 mt-28">
        <div className="relative aspect-[21/9] overflow-hidden">
          <img src={STUDIO_IMG} alt="Atelier" className="h-full w-full object-cover" />
          <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
            <p className="font-display text-3xl md:text-5xl text-white text-center px-6">
              Chaque toile raconte une victoire.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
